export interface ChatSamplePrompt {
  id: string
  /** Full sentence inserted into the composer. */
  prompt: string
  /** Substring of `prompt` rendered in italics. The rest stays muted. */
  emphasis: string
}

export const LISTING_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'improve',
    prompt: 'How can I improve my listings?',
    emphasis: 'improve my listings?',
  },
  {
    id: 'score',
    prompt: 'Which of my listings are Basic vs Strong vs Excellent?',
    emphasis: 'Basic vs Strong vs Excellent?',
  },
  // {
  //   id: 'draft',
  //   prompt: 'Draft a Marketplace listing title and description for my website.',
  //   emphasis: 'Marketplace listing title and description',
  // },
  {
    id: 'unpublished',
    prompt: 'Which listings are still unpublished or missing required details?',
    emphasis: 'unpublished or missing required details?',
  },
  {
    id: 'failed',
    prompt: 'Which of my listings failed, and why?',
    emphasis: 'failed, and why?',
  },
]

export const OFFER_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'expiring',
    prompt: 'Which offers are expiring this month?',
    emphasis: 'expiring this month?',
  },
  {
    id: 'acceptance',
    prompt: 'Which offers are still waiting on buyer acceptance?',
    emphasis: 'waiting on buyer acceptance?',
  },
  {
    id: 'summary',
    prompt:
      'Give me a summary of all my private offers by status for the last 30 days.',
    emphasis: 'last 30 days.',
  },
  {
    id: 'value',
    prompt: "What's the total value of my open private offers?",
    emphasis: 'total value',
  },
]

export const RESELLER_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'active',
    prompt: 'Show my active reseller agreements.',
    emphasis: 'active reseller agreements.',
  },
  {
    id: 'attention',
    prompt: 'Which reseller agreements need my attention?',
    emphasis: 'need my attention?',
  },
  {
    id: 'summary',
    prompt:
      'Give me a summary of all my reseller agreements by status for the last quarter.',
    emphasis: 'last quarter.',
  },
  {
    id: 'expiring',
    prompt: 'Which reseller agreements are expiring in the next 30 days?',
    emphasis: 'next 30 days?',
  },
]

export const CONTRACT_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'active',
    prompt: 'Show me all active contracts.',
    emphasis: 'active contracts.',
  },
  {
    id: 'expiring',
    prompt: 'Which contracts are expiring in the next 30 days?',
    emphasis: 'expiring in the next 30 days?',
  },
  {
    id: 'summary',
    prompt: 'Give me a summary of my contracts by status for the last 30 days.',
    emphasis: 'last 30 days.',
  },
  {
    id: 'product',
    prompt: 'Break down my active contracts by product.',
    emphasis: 'by product.',
  },
]

export const REVENUE_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'range',
    prompt: 'Show my marketplace revenue for the last 6 months.',
    emphasis: 'last 6 months.',
  },
  {
    id: 'product',
    prompt: 'Break down revenue by product for the last quarter.',
    emphasis: 'last quarter.',
  },
  {
    id: 'disbursements',
    prompt: 'What disbursements are due in the next 30 days?',
    emphasis: 'next 30 days?',
  },
  {
    id: 'compare',
    prompt: "How does this quarter's revenue compare with last quarter?",
    emphasis: 'last quarter?',
  },
]

export const PROPENSITY_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'likely',
    prompt: 'Which of my prospects are most likely to buy?',
    emphasis: 'most likely to buy?',
  },
  {
    id: 'common',
    prompt: 'What do my highest-scoring prospects have in common?',
    emphasis: 'highest-scoring prospects',
  },
  {
    id: 'first',
    prompt: 'Which prospects should I reach out to first?',
    emphasis: 'reach out to first?',
  },
  {
    id: 'dropped',
    prompt: 'Which prospects dropped in score since last month?',
    emphasis: 'dropped in score',
  },
]

export const FUNDING_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'potential',
    prompt: "What's my potential funding?",
    emphasis: 'potential funding?',
  },
  {
    id: 'mpopp',
    prompt: 'Which opportunities are eligible for MPOPP?',
    emphasis: 'eligible for MPOPP?',
  },
  {
    id: 'qualify',
    prompt: 'Which opportunities need updates to qualify for funding?',
    emphasis: 'qualify for funding?',
  },
  {
    id: 'received',
    prompt:
      "How much funding have I received this year, and what's still pending?",
    emphasis: "what's still pending?",
  },
]

export const METERING_CHAT_PROMPTS: ChatSamplePrompt[] = [
  {
    id: 'last-month',
    prompt: 'Show metering records for the last month.',
    emphasis: 'last month.',
  },
  {
    id: 'usage',
    prompt: 'Summarize metering usage by product for the last quarter.',
    emphasis: 'last quarter.',
  },
  {
    id: 'failing',
    prompt: 'Why are my metering submissions failing?',
    emphasis: 'failing?',
  },
  {
    id: 'buyers',
    prompt: 'Which buyers have the highest metered usage this quarter?',
    emphasis: 'highest metered usage',
  },
]
